import { apiKeyRoutes } from '@/repository/tenant';
const { Generate, Remove, Check, Show, Update, Rotate } = apiKeyRoutes;

export default {
	namespaced: true,
	actions: {
		async store({ }) {
			try { return await Generate() }
			catch (error) {
				console.error('Could not generate an API Key.', error);
				throw error;
			}
		},
		async destroy({ }) {
			try { return await Remove() }
			catch (error) {
				console.error('Could not remove API Key', error);
				throw error;
			}
		},
		async show({ }, data = { hideKey: true }) {
			try { return await (data.hideKey ? Check() : Show()) }
			catch (error) {
				console.error('Could not get API Key.', error);
				throw error;
			}
		},
		async update({ }, data = {}) {
			try { return await Update({ data }) }
			catch (error) {
				console.error('Could not update API Key.', error);
				throw error;
			}
		},
		async storeFresh({ }) {
			try { return await Rotate() }
			catch (error) {
				console.error('Could not rotate API Key.', error);
				throw error;
			}
		}
	}
}